import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { RouteService } from './route.service';
import { environment } from '../../environments/environment';
import { ApplicationStateService } from './application-state.service';
import { DictionaryEntry } from '../models/dictionary-entry';

@Injectable({
    providedIn: 'root'
})
export class DictionaryService {

    constructor(private restService: RestService,
                private applicationStateService: ApplicationStateService,
                private routeService: RouteService) {
    }

    getEntryByWord(searchTerm: string): Promise<Array<DictionaryEntry>> {

        return new Promise((resolve, reject) => {
            const route: string = this.routeService.getRelativeRoute(environment.endpointUrls.dictionary,
                {
                    q: searchTerm,
                    bookId: this.applicationStateService.bookId
                });

            this.restService.get(route)
                .then(result => {
                    resolve(result as Array<DictionaryEntry>);
                })
                .catch(err => reject(err));
        });
    }
}
